<div class="gauge-graph-table-row text">
    <div class="col-no">
        {{ rowIndex + 1 }}
    </div>
    <div class="col-channel">
        <ng-container *ngIf="!channel.channel">
            <div class="select-button" (click)="openChannelSelector()">
                {{ 'graph.gauge.table.channel.button.select' | translate }}
            </div>
        </ng-container>
        <ng-container *ngTemplateOutlet="channelRow; context: { channel: channel.channel }"></ng-container>
    </div>
    <div class="col-scale-division" [class.active]="isDropdownOpen">
        <div #dropdownButton class="dropdown-selected" (click)="toggleDropdown()">
            {{ channel.scaleDivision || 'graph.gauge.table.scale-division.select' | translate }}
            <mat-icon class="arrow" svgIcon="dropdown-arrow" [class.focus]="isDropdownOpen"> </mat-icon>
        </div>

        <div #dropdownMenu class="dropdown-menu" *ngIf="isDropdownOpen">
            <div
                class="dropdown-item"
                *ngFor="let num of numbers"
                (click)="setScaleDivision(num)"
                [class.bold]="num === this.channel.scaleDivision">
                {{ num }}
                <mat-icon class="value-checked" svgIcon="check" *ngIf="num === this.channel.scaleDivision"> </mat-icon>
            </div>
        </div>
    </div>
    <div class="col-options" #iconButton>
        <app-more-options-dropdown
            [isOpen]="optionsVisible"
            (toggle)="openOptions()"
            [options]="moreOptions"
            (optionSelected)="onMoreOptionSelected($event)">
        </app-more-options-dropdown>
    </div>
</div>

<ng-template #channelRow let-channel="channel" let-selector="selector">
    <div class="channel-row" *ngIf="channel">
        <div>{{ channel.fcuData.fcuChannelId }}</div>
        <div class="channel-name">{{ channel.opsData.name }}</div>
        <div class="select-button" (click)="openChannelSelector()">
            {{ 'graph.gauge.table.channel.button.change' | translate }}
        </div>
    </div>
</ng-template>
